module.exports = __webpack_public_path__ + "static/media/x.d85ddd23.svg";